export const defaultVideoSizes: AdSizeOption[] = [
  {
    type: 'video',
    value: '320p',
    label: '320p (568x320)',
    width: '568',
    height: '320'
  },
  {
    type: 'video',
    value: '480p',
    label: '480p (854x480)',
    width: '854',
    height: '480'
  },
  {
    type: 'video',
    value: '720p',
    label: '720p (1280x720)',
    width: '1280',
    height: '720'
  },
  {
    type: 'video',
    value: '1080p',
    label: '1080p (1920x1080)',
    width: '1920',
    height: '1080'
  },
  {
    type: 'video',
    value: '360p',
    label: '360p (640x360)',
    width: '640',
    height: '360'
  },
]

export const initialFormData: AdSizeFormData = {
  width: '',
  height: '',
  name: '',
  label: '',
  type: 'image' as AdSizeType
}
